<template>
    <asli-quote-declined :title="ErrorPageText().general.title">
        <div
            class="text-center"
            v-html="
                quoteReference
                    ? ErrorPageText(BRAND_PHONE_NUMBER).general.descriptionWithReference(quoteReference)
                    : ErrorPageText(BRAND_PHONE_NUMBER).general.description
            "
        />
    </asli-quote-declined>
    <asli-divider class="my-[30px]" />
    <div class="text-center md:text-left">
        <asli-button
            id="error-return-to-homepage"
            class="mb-[30px]"
            color="primary"
            @click="isOfflineQuote ? goBack() : goHome()"
        >
            {{ isOfflineQuote ? "Back" : "Return to Homepage" }}
        </asli-button>
    </div>
</template>

<script lang="ts" setup>
import { AsliDivider, AsliQuoteDeclined, AsliButton } from "@mbs-npm/anpost-ui";
import { getResolvedRouteName } from "@/router/utils";
import { ROUTE_NAMES } from "@/router/types";
import { useRouter } from "vue-router";
import { ErrorPageText } from "@/utils/labels";
import { useProposalStore } from "@/stores/risk/risk";
import { computed } from "vue";
import { BRAND_PHONE_NUMBER } from "@/static/constants";
import useNavigationHelpers from "@/router/helpers";

const router = useRouter();

const { proposal } = useProposalStore();
const { goToPreviouslyRecordedRoute } = useNavigationHelpers();

const quoteReference = computed(() => proposal.quote?.reference ?? null);
const isOfflineQuote = computed(() => proposal?.recalled_from_offline);

function goHome() {
    router.push({
        name: getResolvedRouteName(ROUTE_NAMES.AboutYou, router.currentRoute.value),
        query: {
            uuid: proposal.uuid
        }
    });
}

function goBack() {
    goToPreviouslyRecordedRoute();
}
</script>
